import Button from 'components/Shared/Elements/Button';
import { Link } from 'i18n';
import { memo } from 'react';

export default memo(({ text, className, url }) => (
  <Button className={className} href={url}>
    {text}
  </Button>
));
